module.exports = __webpack_public_path__ + "img/5.ac7bfa15.jpg";